export default __webpack_public_path__ + "1bfb760ee8250ac56dd9c49a90757fc4.svg";